import fetchRetry from "fetch-retry";
import { MAX_API_RETRIES } from "./retryPolicy";

interface HttpResponse<T> extends Response {
  parsedBody?: T;
}
export async function jsonFetch<T>(request: RequestInfo): Promise<T> {
  const response: HttpResponse<T> = await fetchRetry(fetch, {
    retries: MAX_API_RETRIES,
    retryDelay: 400
  })(request, {
    headers: {
      Accept: "application/json"
    }
  });
  return response.json();
}
